

import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography
} from '@mui/material';

const BackWindowModal = ({
  open,
  onClose,
  onConfirm,
  disableConfirm = false // optional prop
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirmation</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1" component="div">
          <ul style={{ margin: 0, paddingLeft: '1.25rem' }}>
            <li>Warning! you are attempting to exit this page - any previously entered data will be lost?</li>
          </ul>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}   sx={{
          backgroundColor: '#ec008c',
          color: 'white',
          '&:hover': {
            backgroundColor: '#d5006d',
          },
        }}>Cancel</Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          //color="primary"
          sx={{
          backgroundColor: '#ec008c',
          color: 'white',
          '&:hover': {
            backgroundColor: '#d5006d',
          },
        }}
          disabled={disableConfirm}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BackWindowModal;
